import React, { useState } from "react";
import NavTitle from "./NavTitle";
import { useTranslation } from "react-i18next";

const Price = ({ onPriceFilter }) => {
  const { t } = useTranslation();
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);

  const priceList = [
    {
      _id: 950,
      priceOne: 0.0,
      priceTwo: 49.99,
      label: "Budget Friendly"
    },
    {
      _id: 951,
      priceOne: 50.0,
      priceTwo: 99.99,
      label: "Mid-Range"
    },
    {
      _id: 952,
      priceOne: 100.0,
      priceTwo: 199.99,
      label: "Premium"
    },
    {
      _id: 953,
      priceOne: 200.0,
      priceTwo: 399.99,
      label: "High-End"
    },
    {
      _id: 954,
      priceOne: 400.0,
      priceTwo: 599.99,
      label: "Luxury"
    },
    {
      _id: 955,
      priceOne: 600.0,
      priceTwo: 1000.0,
      label: "Ultra Premium"
    },
  ];

  const handlePriceRangeSelect = (range) => {
    const newSelectedRange = selectedPriceRange === range ? null : range;
    setSelectedPriceRange(newSelectedRange);
    onPriceFilter(newSelectedRange);
  };

  return (
    <div className="w-full bg-white shadow-lg rounded-xl p-5 transition-all duration-300">
      <NavTitle title={t("shop.Shop_by_Price")} icons={false} />

      <div className="space-y-3 mt-4">
        {priceList.map((item) => (
          <div
            key={item._id}
            className={`
              flex items-center justify-between 
              cursor-pointer 
              p-3
              rounded-lg
              transition-all duration-200 ease-in-out
              transform hover:scale-[1.02]
              ${selectedPriceRange === item
                ? 'bg-gradient-to-r from-blue-50 to-blue-100 shadow-sm border border-blue-200'
                : 'hover:bg-gray-50 border border-transparent'}
            `}
            onClick={() => handlePriceRangeSelect(item)}
          >
            <div className="flex-1">
              <span className={`
                font-medium text-sm
                ${selectedPriceRange === item ? 'text-primeColor' : 'text-gray-700'}
              `}>
                {item.label}
              </span>
              <div className={`
                text-xs mt-1
                ${selectedPriceRange === item ? 'text-blue-600' : 'text-gray-500'}
              `}>
                EGP {item.priceOne.toFixed(2)} - EGP {item.priceTwo.toFixed(2)}
              </div>
            </div>
            {selectedPriceRange === item && (
              <div className="text-primeColor">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>

      {selectedPriceRange && (
        <div className="mt-6 bg-gradient-to-r from-gray-50 to-white p-4 rounded-lg border border-gray-100">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-sm font-semibold text-gray-700">
              Selected Range
            </h3>
            <button
              onClick={() => handlePriceRangeSelect(selectedPriceRange)}
              className="text-xs px-3 py-1 rounded-full bg-red-50 text-red-500 hover:bg-red-100 transition-colors duration-200"
            >
              Clear
            </button>
          </div>
          <div className="flex flex-col space-y-1">
            <span className="text-primeColor font-medium">
              {selectedPriceRange.label}
            </span>
            <span className="text-sm text-gray-600">
              EGP {selectedPriceRange.priceOne.toFixed(2)} - EGP {selectedPriceRange.priceTwo.toFixed(2)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Price;